import {Component, OnInit} from '@angular/core';
import {downgradeComponent} from '@angular/upgrade/static';
import * as angular from 'angular';
import {CookieService} from 'ngx-cookie';
@Component({
	selector: 'tt-admin-login-panel',
	templateUrl: './admin-login-panel.component.html',
	styleUrls: ['./admin-login-panel.component.scss']
})
export class AdminLoginPanelComponent implements OnInit {

	public isVisible: boolean = false;
	public admin: { name: string; accessKey: string; } = null;


	constructor(private cookieService: CookieService) {

	}

	ngOnInit(): void {
		if (this.cookieService.get('admin_mode')) {
			this.isVisible = true;
			this.admin = <any>this.cookieService.getObject('admin_mode');
		}
	}

	public getBackToAdminAccount(): void {
		this.cookieService.remove('admin_mode');
		document.location.href = `${document.location.origin}/login.html?access_key=${this.admin.accessKey}`;
	}

}


angular.module('timetracker2')
	.directive(
		'ttAdminLoginPanel',
		downgradeComponent({ component: AdminLoginPanelComponent }) as angular.IDirectiveFactory
	);



// WEBPACK FOOTER //
// ./src/app/core/components/admin-login-panel.component.ts